export default __webpack_public_path__ + "static/media/heart-filled.200c545c.svg";